import { render, staticRenderFns } from "./ModalSalesByClient.vue?vue&type=template&id=1124562c"
import script from "./ModalSalesByClient.vue?vue&type=script&lang=js"
export * from "./ModalSalesByClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports